import { createTheme, ThemeProvider } from "@mui/material/styles";
declare module "@mui/material/styles" {
  interface Theme {
    brandColor: string;
    inforamtionColor: string;
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    brandColor?: string;
    inforamtionColor?: string;
  }
}

export const theme = createTheme({
  palette: {
    mode: "dark",
  },
  brandColor: "#1f8feb",
  inforamtionColor: "#aaa",
});
